import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import imgurl from "../assests/images/imgurl";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Typography , Grid, Button } from "@mui/material";
import i18next from "i18next";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import CloseIcon from "@mui/icons-material/Close";

export default function MobileHeader({showDrawer}) {
  const [open, setOpen] = React.useState(false);
  const location = useLocation()  
  const navigate = useNavigate()
  const toggleDrawer = () => setOpen((prev) => !prev);

  const handleDrawer = (which, to) => {
    let url 
    if(which === "privacy"){
      url = "https://alopexia.com/policies/privacy-policy"
    } else if(which === "terms"){
      url = "https://alopexia.com/policies/terms-of-service"
    } else if(which === "contact"){
      url = "https://alopexia.com/policies/contact-information"
    } else if(which === "refund"){
      url = "https://alopexia.com/policies/refund-policy"
    }
    window.open(url, "_self");
  }

  const DrawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer}
      onKeyDown={(e) => {
        if (e.key === "Tab" || e.key === "Shift") return;
        toggleDrawer();
      }}
    >
      <List className="MobileMenuItemsList">
        <ListItem disablePadding>
          <ListItemButton
            component="a"
            href="https://alopexia.com/"
            className="navItem active"
          >
            <ListItemText primary="Home" />
          </ListItemButton>
        </ListItem>
        {/* <ListItem disablePadding>
          <ListItemButton
            component="a"
            href="https://alopexia.com/pages/about-alopexia"
            className="navItem"
          >
            <ListItemText primary="About Alopexia" />
          </ListItemButton>
        </ListItem> */}
        {/* <ListItem disablePadding>
          <ListItemButton
            component="a"
            href="https://alopexia.com/for-men"
            className="navItem"
          >
            <ListItemText primary="For Men" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            component="a"
            href="https://alopexia.com/for-women"
            className="navItem"
          >
            <ListItemText primary="For Women" />
          </ListItemButton>
        </ListItem> */}
        {/* <ListItem disablePadding>
          <ListItemButton
            component="a"
            href="https://alopexia.com/our-team"
            className="navItem"
          >
            <ListItemText primary="Our Team" />
          </ListItemButton>
        </ListItem> */}
        {/* <ListItem disablePadding>
          <ListItemButton
            component="a"
            className="navItem"
            onClick={() => navigate('/feedback')}
          >
            <ListItemText primary="Feedback" />
          </ListItemButton>
        </ListItem> */}
      </List>
    
       <hr />

      <Grid container spacing={1} className="mt-5px">
        <Grid item xs={1}></Grid>
          <Grid item xs={5} className="footerCursor" onClick={() => handleDrawer('privacy', 'open')}>
            <Typography className="footerName">{i18next.t("Privacy Policy")}</Typography>
          </Grid>
          <Grid item xs={5} className="footerCursor" onClick={() => handleDrawer('terms', 'open')}>
            <Typography className="footerName">{i18next.t("Terms of Service")}</Typography>
          </Grid>
        <Grid item xs={1}></Grid>
      </Grid>

      <Grid container spacing={1} className="mt-5px">
        <Grid item xs={1}></Grid>
          <Grid item xs={5} className="footerCursor" onClick={() => handleDrawer('contact', 'open')}>
            <Typography className="footerName contactinfo">{i18next.t("Contact Information")}</Typography>
          </Grid>
          {/* <Grid item xs={5} className="footerCursor" onClick={() => handleDrawer('refund', 'open')}>
            <Typography className="footerName">{i18next.t("Refund Policy")}</Typography>
          </Grid> */}
        <Grid item xs={1}></Grid>
      </Grid>

      <Grid container spacing={1} className="mt-5px mb-10px d-flex justify-content-center align-items-center">
        <Grid item xs={10}>
          <Typography className='footerName'>{i18next.t("© 2025 Alopexia All Rights Reserved")}</Typography>
        </Grid>
      </Grid>

     
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }} className={!showDrawer ? "mobileAppBar" : "mobileAppBar loginpagenavbar"}>
      {
        !showDrawer ?
          <AppBar position="static">
            <Toolbar sx={{ justifyContent: "center", position: "relative" }}>
              {/* Logo in the center */}
              <Link to="https://alopexia.com/" className="linkingIconHeader">
                <img
                  src={imgurl.hairlossaiLogo}
                  alt="New Logo"
                  className="headerLogo mainlogo"
                  
                />
              </Link>

              {/* Menu Icon on the left */}
              <Button className="sidebaricon" 
                onClick={toggleDrawer} 
                sx={{
                  position: "absolute",
                  right: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                <DensityMediumIcon />
              </Button>
            </Toolbar>
          </AppBar> :
        !open ?
            <Button className="sidebaricon helloo" 
              onClick={toggleDrawer} 
              sx={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
            <DensityMediumIcon />
          </Button> :
        ''
      }
      
      <SwipeableDrawer
        anchor="right"
        open={open}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
        className={location?.pathname != "/" ? "drawerMobile" : "drawerMobile landing"}
      > 
        {
          location?.pathname != "/" &&
            <div className="closeSidebar">
              <img src={imgurl.hairlossaiLogo} className="sidebarLogo"/>
              <CloseIcon className="cursor-pointer" onClick={() => toggleDrawer()}/>
            </div>
        }
        {DrawerList}
      </SwipeableDrawer>
    </Box>
  );
}
